<div class="it-splitter" (mousedown)="onStartResize($event)" (touchstart)="onStartResize($event)" role="separator" aria-orientation="vertical" aria-label="Resize response panel">
	<div class="it-splitter-grip"></div>
</div>
